/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Action to perform on the documents
 */
export enum BulkUpdateDocumentClassifierAction {
    ADD = 'add',
    REMOVE = 'remove',
}
